import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { getSpecialitiesSingle, updateSpeciality } from "../../../../services/speciality";
import { useEffect, useState } from "react";
import { emptySpeciality, Speciality } from "../../../../interfaces/speciality";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminSpecialityEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSpecialityEdit(props: AdminSpecialityEditProps) {
    const [speciality, setSpeciality] = useState<Speciality>(emptySpeciality);
    const [media, setMedia] = useState<Media[]>([]);

    useEffect(() => {
        debugger;
        getSpecialitiesSingle(props.id)
            .then(response => {
                const newMedia = response.data.icon.map((m: Media) => {
                    return m;
                });
                setMedia(newMedia);
                setSpeciality(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            code: event.target.code.value,
            description: event.target.description.value,
            icon: media.length > 0 ? media[0].id : 0
        }
        updateSpeciality(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="admin-speciality-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_speciality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { speciality.id == 0 && 
                    <LoadingSpinner />
                }
                { speciality.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ speciality.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ speciality.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="code">
                                <Form.Label aria-required="true">{ t("code") }</Form.Label>
                                <Form.Control type="text" name="code" required
                                    defaultValue={ speciality.code } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea"
                                    defaultValue={ speciality.description } />
                            </Form.Group>
                            <Form.Group className="mb-3 media-field" controlId="media">
                                <Uploader title={ t("icon_upload_message") }
                                    media={ media } save={ handleMediaEventUpload } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}